import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-package',
  templateUrl: './health-package.component.html',
  styleUrls: ['./health-package.component.css']
}) 
export class HealthPackageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  hideshow1() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");
  
    if (dots.style.display === "none") {
      dots.style.display = "inline";
      btnText.innerHTML = "Read more <i class='fa fa-caret-down'></i>";
      moreText.style.display = "none";
    } else {
      dots.style.display = "none";
      btnText.innerHTML = "Read less <i class='fa fa-caret-up'></i>";
      moreText.style.display = "inline";
    }
  }

  hideshow2() {
    var dots = document.getElementById("dots2");
    var moreText = document.getElementById("more2");
    var btnText = document.getElementById("myBtn2");
  
    if (dots.style.display === "none") {
      dots.style.display = "inline";
      btnText.innerHTML = "Read more <i class='fa fa-caret-down'></i>";
      moreText.style.display = "none";
    } else {
      dots.style.display = "none";
      btnText.innerHTML = "Read less <i class='fa fa-caret-up'></i>";
      moreText.style.display = "inline";
    }
  }

  hideshow3() {
    var dots = document.getElementById("dots3");
    var moreText = document.getElementById("more3");
    var btnText = document.getElementById("myBtn3");
  
    if (dots.style.display === "none") {
      dots.style.display = "inline";
      btnText.innerHTML = "Read more <i class='fa fa-caret-down'></i>";
      moreText.style.display = "none";
    } else {
      dots.style.display = "none";
      btnText.innerHTML = "Read less <i class='fa fa-caret-up'></i>";
      moreText.style.display = "inline";
    }
  }

  redirectToRedCliffe(){
    // window.location.replace("https://iframeprod.redcliffelabs.com/?partner_id=SecureNow&reference="+localStorage.getItem('mobileNumber'))
    window.location.replace("https://iframepartner.redcliffelabs.com/?pid=3p_pqJv6FQ2Qc5qWfjPRG&reference="+localStorage.getItem('mobileNumber'))
  }
 

}
